import { useState } from "react";
import {
  FIRST_STEP_BUTTON_TEXT,
  FIRST_STEP_SUBTITLE,
  FIRST_STEP_TITLE,
  LABEL,
  SECOND_STEP_BUTTON_TEXT,
  SECOND_STEP_SUBTITLE,
  SECOND_STEP_TITLE
} from "../DraftHeaderConsts";

function validateDescription(text) {
  // eslint-disable-next-line no-useless-escape
  const disallowedCharsRegex = /[<>#*_\[\]()&'"]/;
  return !disallowedCharsRegex.test(text);
}

// `skipConfirmStep`: the review-changes dialog already asked for confirmation, so start at the description.
const usePublishDialog = ({ handleSubmit, onClose, skipConfirmStep = false }) => {
  let dialogContent = {};
  const firstStep = skipConfirmStep ? 1 : 0;
  const [step, setStep] = useState(firstStep);
  const [changeDescription, setChangeDescription] = useState("");

  const handlePublish = () => {
    handleSubmit({ changeDescription });
    onClose();
  };

  if (step === 0) {
    dialogContent = {
      step,
      title: FIRST_STEP_TITLE,
      subtitle: FIRST_STEP_SUBTITLE,
      actionButtonText: FIRST_STEP_BUTTON_TEXT,
      handlePublish: () => setStep(1),
      handleCancel: () => onClose()
    };
  }
  else if (step === 1) {
    const isValid = validateDescription(changeDescription);
    const disablePublish = !changeDescription || !isValid;

    dialogContent = {
      step,
      title: SECOND_STEP_TITLE,
      subtitle: SECOND_STEP_SUBTITLE,
      actionButtonText: SECOND_STEP_BUTTON_TEXT,
      label: LABEL,
      changeDescription,
      setChangeDescription,
      handlePublish,
      disablePublish,
      error: isValid ? "" : "Description contains disallowed characters",
      handleKeyPress: event => {
        if (event.key === "Enter" && !disablePublish) {
          handlePublish();
        }
      },
      handleCancel: () => {
        onClose();
        setStep(firstStep);
      }
    };
  }

  return { dialogContent };
};

export default usePublishDialog;
